import __ from "standard/dunder";

const didPaint = (target, propertyKey) => {
  Reflect.defineProperty(target, __.didPaint__, {
    value() {
      return this[propertyKey](...arguments);
    },
    writable: true,
  });
};

export default didPaint;
